import React from 'react'
import { Link } from 'react-router-dom'

export default function About(props) {

//  const [myStyle, setMyStyle] = useState({
//     color: 'black',
//     backgroundColor: 'white'
// });

let myStyle = {
    color: props.mode === 'dark'?'white':'#042743',
    backgroundColor: props.mode === 'dark'?'#042743':'white'
}
   
    return (
        <div className='container' style={myStyle}>
            <h1 className='my-3'>About Us</h1>
            <div className="accordion" id="accordionExample" style={myStyle}>
                <div className="accordion-item" style={myStyle}>
                    <h2 className="accordion-header">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style={myStyle}>
                            <strong><i>Analyze your text</i></strong>
                        </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                        Textutils gives you a way to analyze your text <i>quickly</i> and <i>efficiently</i>. Be it word count, character count or formatting text in an efficient manner.
                        </div>
                    </div>
                </div>
                <div className="accordion-item" style={myStyle}>
                    <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" style={myStyle}>
                            <strong><i>Free to use</i></strong>
                        </button>
                    </h2>
                    <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body" >
                        TextUtiIs is a <i>free character counter tool</i>  that provides instant character count & word count statistics for a given Text. TextUti1s reports the number of words and characters. Thus it is suitable for writing text with word character limit.
                        </div>
                    </div>
                </div>
                <div className="accordion-item" style={myStyle}>
                    <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" style={myStyle}>
                            <strong><i>Browser Compatible</i></strong>
                        </button>
                    </h2>
                    <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                        This word manipulater software works in any web browsers such as <i>Chrome, Firefox, Internet Explorer, Safari, Opera.</i> It suits to count characters in facebook, blog, books, excel document, pdf document, essays, etc.
                        </div>
                    </div>
                </div>
                <div className="accordion-item" style={myStyle}>
                    <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour" style={myStyle}>
                            <strong><i>Made with Care</i></strong>
                        </button>
                    </h2>
                    <div id="collapseFour" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                        Hi, I am <i>Aniket Chakraborty</i> and this is my first <i>react js</i> project where I got to learn about a lot about the components as well hooks and many more functionalities.    
                        <i><Link to={"https://github.com/aniketrick/textUtils"}>Git</Link> </i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
